import {Graphics} from 'pixi.js';
import {StaticData} from '../../data/StaticData';

export class SimpleRoundedRect extends Graphics
{
    color: number = 0;
    radius: number = 0;

    constructor() {
        super();

        this.color = 0xffffff;
        this.radius = StaticData.sceneMaskRadius;
    }

    /**
     * Отрисовка  маски игрового поля
     * @param width - ширина
     * @param height - высота
     * @param color - цвет границы
     * @param radius - радиус закругления углов
     */
    draw(width: number, height: number, color: number, radius: number, padding: number): void {
        this.clear();
        this.lineStyle(0, 0x777777);
        this.beginFill(color);
        this.drawRoundedRect(padding, padding, width - padding * 2, height - padding * 2, radius);
        this.endFill();
    }
}
